export default {
  snackbar: {
    acceptInvite: "Einladung wird akzeptiert",
    acceptInviteSuccess: "Du bist nun Mitglied von {{name}}",
    acceptInviteFailed: "Irgendwas ist schief gelaufen..."
  }
};
